// extracted by mini-css-extract-plugin
export default {"button":"HeaderPrimaryButton_button__b1etb"};